import './ChangeCloseDateModalStyle.less';

import { DatePicker, Modal, MultiLineInput } from '@opendoor/bricks';
import moment from 'moment';
import React from 'react';

export interface IChangeCloseDateModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSubmit: (newDate: moment.Moment, reason: string) => void;
}

interface IChangeCloseDateModalState {
  newDate: moment.Moment;
  reason: string;
}

export default class ChangeCloseDateModal extends React.PureComponent<
  IChangeCloseDateModalProps,
  IChangeCloseDateModalState
> {
  public state = {
    newDate: null,
    reason: '',
  };

  public render(): JSX.Element {
    const { isOpen, onRequestClose } = this.props;
    const { newDate, reason } = this.state;

    return (
      <Modal isOpen={isOpen} maxWidth={650} onRequestClose={onRequestClose}>
        <div className="od-change-close-date-modal">
          <h5>Change closing date</h5>
          <div className="row new-closing-date">
            <div className="col-xs-3">New closing date</div>
            <div className="col-xs-4">
              <DatePicker
                onDateChange={newDate => this.setState({ newDate: moment(newDate) })}
                date={newDate && newDate.toDate()}
              />
            </div>
          </div>
          <MultiLineInput
            content={reason}
            name="reason"
            onChange={(_, reason: string) => this.setState({ reason })}
            placeholder="Please note the reason for the change."
            unboundedWidth={true}
          />
          <p>
            Next, we’ll review your closing date change and get back to you. If approved on our end,
            we’ll have you sign an addendum to confirm our new closing date.
          </p>
          <div className="request-actions">
            <button className="button secondary" onClick={onRequestClose}>
              Cancel
            </button>
            <button
              className="button primary"
              onClick={this.handleSubmit}
              disabled={!newDate || !reason}
            >
              Request change
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  private handleSubmit = () => {
    const { newDate, reason } = this.state;
    this.props.onSubmit(newDate, reason);
    this.setState({ newDate: null, reason: '' });
  };
}
